<perfect-scrollbar>
  <div class="container">
    <div class="row justify-content-center ">
      <div class="col-7 p-0 text-center logo">
        <img src="../../../assets/images/logo-full.png" width="241" height="80">
      </div>
      <div class="panel col-7">
        <h3 class="mb-4">{{"FORGOT_PASSWORD_PAGE.title" | translate}}</h3>
        <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email">{{'FORM.label.email' | translate}}</label>
            <input id="email" type="text" formControlName="email" class="form-control custom"
                   placeholder="{{'FORM.placeholder.email' | translate}}" autocomplete="off"/>
            <div class="invalid-feedback" *ngIf="form.email.errors && isSubmittedForm">
              <span *ngIf="form.email.errors.required">{{"FORM.error.email_required" | translate}}</span>
              <span *ngIf="form.email.errors.email">{{"FORM.error.email_format" | translate}}</span>
            </div>
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="errorMessage" [innerHTML]="'FORM.server_error.' + errorMessage | translate">
          </div>
          <div class="form-group-btn">
            <button class="btn btn-primary">{{'FORM.button.forgot-password' | translate}}</button>
          </div>
        </form>
      </div>
      <div class="col-7 p-0">
        <div class="btn-group link-dropdown lang-dropdown" dropdown [dropup]="true" *ngIf="currentLanguage">
          <a id="language-dropdown" dropdownToggle type="button" class="dropdown-toggle">
            {{currentLanguage.display}} <span class="caret"></span>
          </a>
          <ul id="dropdown-custom-html" *dropdownMenu class="dropdown-menu"
              role="menu" aria-labelledby="language-dropdown">
            <li *ngFor="let lang of languages" role="menuitem"
                [ngClass]="{'active': currentLanguage.key === lang.key}"
                (click)="onChangeLanguage(lang)">{{lang.display}}
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 12.4 9.2" style="enable-background:new 0 0 12.4 9.2;" xml:space="preserve">
                <path d="M12.4,0.8c0,0.2-0.1,0.4-0.2,0.6L4.6,9C4.4,9.1,4.2,9.2,4,9.2C3.8,9.2,3.6,9.1,3.4,9L0.2,5.8c-0.3-0.3-0.3-0.9,0-1.2
                  c0.3-0.3,0.9-0.3,1.2,0L4,7.2l6.9-6.9c0.3-0.3,0.9-0.3,1.2,0C12.3,0.4,12.4,0.6,12.4,0.8z"/>
              </svg>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</perfect-scrollbar>


<div bsModal #registrationSuccessfulModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-sm alert-modal">
    <div class="modal-content">
      <button type="button" class="close pull-right" aria-label="Close" (click)="registrationSuccessfulModal.hide()">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
          <path d="M15.7,14.6c0.3,0.3,0.3,0.8,0,1.2c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2L8,9.1l-6.6,6.6C1.2,15.9,1,16,0.8,16
          c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2L6.8,8L0.2,1.4c-0.3-0.3-0.3-0.8,0-1.2c0.3-0.3,0.8-0.3,1.2,0L8,6.8l6.6-6.6
          c0.3-0.3,0.8-0.3,1.2,0c0.3,0.3,0.3,0.8,0,1.2L9.1,8L15.7,14.6z"/>
        </svg>
      </button>
      <div class="modal-body text-center">
        <div class="icon-box">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 37.9 27.8" style="enable-background:new 0 0 37.9 27.8;" xml:space="preserve">
                      <path d="M37.4,0.6c-0.7-0.7-1.9-0.7-2.7,0L12,23.3l-8.7-8.7c-0.7-0.7-1.9-0.7-2.7,0c-0.7,0.7-0.7,1.9,0,2.7l10.1,10.1
            c0.7,0.7,1.9,0.7,2.7,0L37.4,3.2C38.1,2.5,38.1,1.3,37.4,0.6z"/>
          </svg>
        </div>
        <h4>{{"FORGOT_PASSWORD_PAGE.email_sent" | translate}}</h4>
        <p>{{"FORGOT_PASSWORD_PAGE.check_emails" | translate}}</p>

      </div>
    </div>
  </div>
</div>

